import { VALID_APPRAISAL_QUERY_TAB_VALUES } from 'site-modules/shared/components/appraisal/appraisal-tabs/constants';

/**
 * Validates and normalizes the appraisal query tab parameter.
 * Only allows valid tab values defined in VALID_APPRAISAL_QUERY_TAB_VALUES.
 *
 * @param {string} tab - The tab parameter from the query string
 * @returns {string|null} The normalized (uppercase) tab value if valid, null otherwise
 */
export const validateAppraisalQueryTab = tab => {
  if (!tab) return null;

  const appraisalQueryTabUpperCase = tab.toUpperCase();

  if (!VALID_APPRAISAL_QUERY_TAB_VALUES.includes(appraisalQueryTabUpperCase)) {
    return null;
  }

  return appraisalQueryTabUpperCase;
};
